import { render, staticRenderFns } from "./upload-transaction.vue?vue&type=template&id=e70ff90a&"
import script from "./upload-transaction.vue?vue&type=script&lang=js&"
export * from "./upload-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports